import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { promise } from 'protractor';

@Injectable({
  providedIn: 'root'
})
export class DiscountService {

  private endpoint = environment.endpoint;
  private urlCarga = environment.cargaendpoint;
  token: any;

  constructor(
    private httpclient: HttpClient) {
    if (localStorage.getItem('authToken') != null) {
      this.token = localStorage.getItem('authToken')
    } 
   }

  getDiscount(groupId) {
    
    const url = this.urlCarga + '/v1.0/custom-ecarga/settings/app-group/' + groupId +'/promoCode';

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.token,
      })
    };
    return this.httpclient.get(url, httpOptions);
  }

  getPromo(code, token){

    const url = this.urlCarga + '/v1.0.1/custom-ecarga/voucher/promo-code/' + code;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
      })
    };

    return this.httpclient.get(url, httpOptions)
    
  }

  getVouchers(token){
    let url_env = (environment.type === 'stg' || environment.type === 'prod') ? this.urlCarga+'/v1.0.1' : this.urlCarga
    const url = url_env + '/custom-ecarga/voucher/list';

    // let adminToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY2NvdW50SWQiOiI1MTkxY2RiMS1hYzlhLTQ1NWItYjVmMi0wYTUxMjkwOWJhMDUiLCJ1c2VybmFtZSI6ImFkbWluLmNhcmdhIiwidHlwZSI6ImFkbWluIiwiaXNBY3RpdmUiOnRydWUsInZhbGlkYXRpb25TdGF0dXMiOiJwZW5kaW5nIiwiZ3JvdXBJZCI6ImFkbWluLmNhcmdhIiwic29mdERlbGV0ZSI6ZmFsc2UsInJvbGVJZHMiOlsiMmFlOWRlMjktMjQ3MS00Y2Y3LTliNTItNGU0NGZhZjJjNmI3Il0sImxhc3RMb2dnZWRJbkF0IjoxNzE2NDI5NDY2NjU2LCJtcGluIjpmYWxzZSwiaXNEZWFjdGl2YXRlZCI6ZmFsc2UsImlhdCI6MTcxNjQyOTQ2NiwiZXhwIjoxNzE5MDIxNDY2fQ.F5G-igsf_J8a6rB3nWUZtjKO5Kqobc5shDs-Sg28lYE"

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
      })
    };
    return this.httpclient.get(url, httpOptions)
  }

  checkVoucherUses(promo, token){
    const url = this.urlCarga + '/v1.0.1/custom-ecarga/user-voucher/' + promo.vId +'/'+ promo.code;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
      })
    };

    return this.httpclient.get(url, httpOptions)
  }

  validateVoucer(promo) {
    return new Promise(resolve => {
      const url = this.urlCarga + '/v1.0.1/custom-ecarga/validate-voucher/' + promo.vId + '/' + promo.code;
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem("authToken"),
        })
      };

      this.httpclient.get(url, httpOptions)
        .subscribe(async (response) => {
          console.log("response", response)
          resolve(true)
        }, async (err) => {
          resolve(false)
        })
    })


  }

  // getRate(id) {

  //   const url = 'https://api.paymongo.com/v1/payment_methods/' + id;

  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/json',
  //       'Authorization': 'Basic cGtfdGVzdF9GTjdGY2h4UWs4eWlTaEpuZXRHYWloMTg6'
  //     })
  //   };

  //   return this.httpclient.get(url, httpOptions);
  // }

}
